import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { mowerComparison } from "@/lib/puduCatalog";

const MowerComparison = ({ highlight }: { highlight?: "gt3" | "gt5" | "gt7" }) => {
  const col = (key: "gt3" | "gt5" | "gt7") =>
    highlight === key ? "bg-primary/10 text-foreground" : "";

  return (
    <section aria-labelledby="mower-comparison" className="mt-14">
      <h2 id="mower-comparison" className="font-orbitron text-2xl md:text-3xl font-bold">
        Compare GT3, GT5 and GT7
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Manufacturer-published values only. Figures shown as “Not published” are not stated by the
        source page and are not estimated by Neil AI.
      </p>

      <Card className="mt-5 glass-effect border-[hsl(var(--line))] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] border-collapse text-sm">
            <caption className="sr-only">GT3, GT5 and GT7 specification comparison</caption>
            <thead>
              <tr className="border-b border-[hsl(var(--line))]">
                <th scope="col" className="p-3 text-left font-orbitron">Specification</th>
                <th scope="col" className={`p-3 text-left font-orbitron ${col("gt3")}`}>GT3</th>
                <th scope="col" className={`p-3 text-left font-orbitron ${col("gt5")}`}>GT5</th>
                <th scope="col" className={`p-3 text-left font-orbitron ${col("gt7")}`}>GT7</th>
              </tr>
            </thead>
            <tbody>
              {mowerComparison.map((row) => (
                <tr key={row.label} className="border-b border-[hsl(var(--line))] last:border-0 align-top">
                  <th scope="row" className="p-3 text-left font-semibold">{row.label}</th>
                  <td className={`p-3 text-muted-foreground ${col("gt3")}`}>{row.gt3}</td>
                  <td className={`p-3 text-muted-foreground ${col("gt5")}`}>{row.gt5}</td>
                  <td className={`p-3 text-muted-foreground ${col("gt7")}`}>{row.gt7}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="mt-4 flex flex-wrap gap-2">
        <Button asChild variant="outline" size="sm" className="rounded-full"><Link to="/robots/gt3">GT3 details</Link></Button>
        <Button asChild variant="outline" size="sm" className="rounded-full"><Link to="/robots/gt5">GT5 details</Link></Button>
        <Button asChild variant="outline" size="sm" className="rounded-full"><Link to="/robots/gt7">GT7 details</Link></Button>
      </div>
    </section>
  );
};

export default MowerComparison;
